import { define } from "remount";
import { ServiceCarousel } from "../src/Service/ServiceCarousel";
import { LocationServicePageLocations } from "../src/LocationServiceSearch/LocationServicePageLocations";

define({ "service-carousel": ServiceCarousel });
define({ "location-service-page-locations": LocationServicePageLocations });
